import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Api from "./Api/Api";

/*
 * Whether the web store offers "Gift this".
 *
 * The server switch is the one Android reads: config/app_update returns
 * gift_enabled from the app_versions config row's platform key, and the web
 * asks for os=web. No "web" key, or anything but exactly true, means off.
 *
 * ?gift=1 turns it on for this browser tab's session only (sessionStorage),
 * so a release can be tried in prod before the row is flipped. ?gift=0 turns
 * the preview off again.
 */

const PREVIEW_KEY = "fleek_gift_preview";

export const giftPreviewOn = (search = "") => {
  try {
    const q = new URLSearchParams(search).get("gift");
    if (q === "1") sessionStorage.setItem(PREVIEW_KEY, "1");
    else if (q === "0") sessionStorage.removeItem(PREVIEW_KEY);
    return sessionStorage.getItem(PREVIEW_KEY) === "1";
  } catch {
    return false;
  }
};

let pending = null;

/** The server switch, asked once per page load. Fails closed. */
export const fetchGiftEnabled = () => {
  if (!pending) {
    pending = Promise.resolve()
      .then(() => Api.GetAppUpdate())
      .then((res) => {
        // App's interceptor resolves a failed request with the error, so a
        // non-2xx arrives here too. Don't cache that: ask again next time.
        if (!res || res.isAxiosError || res instanceof Error) {
          pending = null;
          return false;
        }
        return res.data?.gift_enabled === true;
      })
      .catch(() => {
        pending = null;
        return false;
      });
  }
  return pending;
};

/** For tests. */
export const resetGiftGate = () => {
  pending = null;
};

export const useGiftEnabled = () => {
  const { search } = useLocation();
  const preview = giftPreviewOn(search);
  const [server, setServer] = useState(false);

  useEffect(() => {
    let live = true;
    fetchGiftEnabled().then((on) => {
      if (live) setServer(on);
    });
    return () => {
      live = false;
    };
  }, []);

  return preview || server;
};
